<div class="flex justify-center" *ngIf="showHorizontalSteps">
    <div class="progress-container">
        <ul
            class="steps"
            [class.disabled]="disabled"
            [ngStyle]="{
                '--steps-count': steps.length,
                '--progress-index': (currentStep - 1)
            }"
        >
        <li
            *ngFor="let step of steps; let i = index"
            [class.active]="isStepActive(i)"
            [class.ctop-progress-bar]="style === 'ctop'"
            [class.complete]="isStepComplete(i)"
            [class.pending]="isStepPending(i)"
        >
        <span class="step-label">
          <span
              class="title"
              [ngClass]="{'no-absolute': noAbsoluteText, 'active': isStepActive(i), 'pending': isStepPending(i)}"
          >{{ step.title || '' | translate }}</span>
          <span
              class="description"
              *ngIf="step.description && showDescription"
          >
            {{ step.description || '' | translate }}
          </span>
        </span>
        </li>
        </ul>
    </div>
</div>

<ul class="timeline p-0 m-0" *ngIf="showVerticalTimeline">
    <li *ngFor="let step of steps; let i = index" class="timeline-item">
        <!-- Línea vertical -->
        <div class="timeline-line" *ngIf="i !== steps.length - 1"></div>

        <!-- Icono (rombo para el primero, flechas para los demás) -->
        <div
            class="timeline-icon"
            [ngClass]="{ arrow: i === steps.length - 1, diamond: i !== steps.length - 1 }"
        ></div>

        <!-- Contenido -->
        <div class="flex flex-col gap-1">
      <span class="typography-body-s-light" [ngClass]="getLabelClasses(i)">
        {{ step.title || '' | translate }}
      </span>
            <span
                *ngIf="step.description"
                class="typography-body-s-regular"
                [ngClass]="getLabelClasses(i)"
            >
        {{ step.description || '' | translate }}
      </span>
        </div>
    </li>
</ul>
